module.exports = __webpack_public_path__ + "static/media/200520-clickerme-homepage-block-02.dafde8ec.jpg";